import DOMPurify from "dompurify";

export default function RichText({ html, className = "" }) {
  return (
    <div
      className={`rich ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "") }}
    />
  );
}
